<template>
    <div class="page">
    <ion-grid fixed>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="rectangle">
        <ion-col>
           <div  class="estimation-cost-wrapper">
        <ion-grid>
          <ion-row>
              <ion-col  size-md="6" size-xs="6">
              <p  class="ion-margin-top fontRobotoBold price-title">Launching Soon...</p>
          </ion-col>
          <ion-col size-md="6" size-xs="6">
              <img class="ion-no-margin text-center carImage" src="https://devapi.rapidevcharge.com/qrcode/images/123.gif" />
              
          </ion-col>
          </ion-row>
        </ion-grid>
      </div>
          
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script>
import { IonCol, IonGrid, IonRow } from "@ionic/vue";
import { defineComponent } from "vue"

export default defineComponent ({
    name: 'corporateManage',
    components: {
      IonGrid, IonRow, IonCol
    },
    data() {
        return {

        }
    },
    async mounted() {
    }
})
</script>

<style scoped>
.carImage {
    width: 10rem;
}
</style>